<template>
  <div class="search-condition-container">
    <condition-title>
      <template #title>
        <span class="text">{{
          $util.capitalize($t('label.search')) + ' ' + $t('label.condition')
        }}</span>
      </template>

      <template #count>
        <span style="color: #737a8c">{{ `(${listCondition.length}/5)` }}</span>
      </template>

      <template #action>
        <lego-icon-button
          v-if="isLogSearchMode && logSqIds.length"
          :disabled="!dataLoaded"
          @click="togglePopup('addMetricShow')"
          iconType="line"
          icon="add_metric"
          class="ui-icon"
          small
          v-lego-tooltip="$t('button.addMetric')"
        />

        <scpm-drop-down :open="popup.exeHistoryShow" @outside-click="togglePopup('exeHistoryShow')">
          <template #anchor>
            <lego-icon-button
              v-if="!isMetricDetailMode && logSqIds.length"
              iconType="line"
              icon="history_condition"
              class="ui-icon"
              style="margin-left: 12px !important"
              @click="togglePopup('exeHistoryShow')"
              small
              v-lego-tooltip="`${$t('label.execution')} ${$t('label.history1')}`"
            />
          </template>
          <div class="execution-history-dialog">
            <exe-history
              v-if="popup.exeHistoryShow"
              :params="modalParam"
              @close="togglePopup('exeHistoryShow')"
              @applyQuery="_setQuery"
            />
          </div>
        </scpm-drop-down>
      </template>
    </condition-title>
    <div class="container">
      <div class="container__wrapper-list-condition">
        <c-scroll @scrolling="onScroll">
          <div class="list">
            <condition-item
              ref="conditionItemRefs"
              v-for="(item, i) in listCondition"
              :key="i"
              :item="item"
              :isCheckScroll="isCheckScroll"
              :index="i"
              :disabled="isMetricDetailMode"
              :logFields="logFields"
              @show-dropdown="showDropdownConditionItem"
              @change="(value) => handleChangeDataItem(value, i)"
              @remove="() => handleRemoveCondition(i)"
            />
          </div>
        </c-scroll>
      </div>
      <div class="container__action" v-show="!isMetricDetailMode">
        <condition-title>
          <template #title>
            <div
              @click="handleAddCondition"
              class="text-add-condition"
              :class="listCondition.length == 5 ? 'disabled' : ''"
            >
              <span style="font-size: 20px; line-height: 12px">+&#160;</span>
              <span>{{ $util.capitalize($t('label.addMoreCondition')) }}</span>
            </div>
          </template>
          <template #action>
            <lego-button @click="handleResetCondition">{{ $t('button.reset') }}</lego-button>
            <lego-button
              :disabled="logSqIds.length == 0 || isDisabledSearch"
              primary
              @click="handleSearch"
              >{{ $t('button.search') }}
            </lego-button>
          </template>
        </condition-title>
      </div>
    </div>

    <add-metric-popup
      v-if="popup.addMetricShow"
      @close="togglePopup('addMetricShow')"
      @saveMetric="handleSaveMetric"
    ></add-metric-popup>
  </div>
</template>
<script>
import _ from 'lodash';
import ConditionTitle from './ConditionTitle.vue';
import ConditionItem from './ConditionItem.vue';
import AddMetricPopup from '@/containers/logs/logCollections/AddMetricPopup';
import ExeHistory from '@/containers/logs/logCollections/ExeHistory';
import ScpmDropDown from '../../../components/scpm/common/ScpmDropDown.vue';

const MODES = {
  logSearch: 'logSearch',
  metricDetail: 'metricDetail'
};

export default {
  name: 'search-condition',
  emits: ['on-save-metric', 'on-reset', 'on-search', 'on-add-condition'],
  inject: ['setCondition'],
  components: {
    ConditionTitle,
    ConditionItem,
    AddMetricPopup,
    ExeHistory,
    ScpmDropDown
  },
  props: {
    searchOptions: {
      type: Array,
      required: true,
      default: () => []
    },
    dataLoaded: {
      type: Boolean,
      default: () => false
    },
    mode: {
      type: String,
      required: true
    },
    logFields: {
      type: Array,
      default: () => []
    },
    logSqIds: {
      type: Array,
      default: () => []
    },
    productType: {
      type: String,
      required: true,
      default: () => ''
    },
    onSearch: {
      type: Function,
      default: () => {}
    },
    onReset: {
      type: Function,
      default: () => {}
    },
    onSaveMetric: {
      type: Function
    }
  },
  data() {
    return {
      listCondition: [],
      popup: {
        exeHistoryShow: false,
        addMetricShow: false
      },
      productTypeCodes: [],
      isCheckScroll: false,
      isDisabledSearch: false
    };
  },
  watch: {
    searchOptions: {
      handler(value) {
        this.validateInputSearch();
        this.listCondition = this.$util.deepCopy(value);
      },
      immediate: true,
      deep: true
    },
    logFields: {
      handler(value) {
        if (value.length > 0) {
          const isCheck = (arr) => {
            return this.listCondition.every((list) => {
              const idx = arr.findIndex((val) => val.logFieldName === list.field);
              return idx > -1;
            });
          };
          if (!isCheck(value)) {
            this.listCondition = [];
            this.listCondition.push({
              operator: 'AND',
              field: 'message',
              compare: 'like',
              value: ''
            });
          }
        }
      },
      deep: true
    }
  },
  computed: {
    modalParam() {
      return {
        selectedLog: this.logSqIds,
        productTypeCode: this.productType,
        productTypeName: _.find(this.productTypeCodes, {
          productTypeCode: this.productType
        }).productTypeName
      };
    },
    isMetricDetailMode() {
      return this.mode === MODES.metricDetail;
    },
    isLogSearchMode() {
      return this.mode === MODES.logSearch;
    }
  },
  created() {
    this._getProductTypeCodes();
  },
  mounted() {},
  methods: {
    async _getProductTypeCodes() {
      await this.$http.log.getLogProductTypes().then((data) => {
        this.productTypeCodes = data;
      });
    },
    validateInputSearch() {
      this.isDisabledSearch = false;
      const searchOptions = this.searchOptions;
      for (let index = 0; index < searchOptions.length; index++) {
        const element = searchOptions[index];
        const value = element.value;
        const checkWhiteSpace = value.trim();
        if (checkWhiteSpace.length > 0) {
          const isPassText = /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9\s]/g.test(value);
          if (isPassText) {
            this.isDisabledSearch = true;
            break;
          }
        } else {
          continue;
        }
      }
    },
    handleRemoveCondition(idx) {
      this.setCondition(true);
      this.listCondition.splice(idx, 1);
      this.$emit('on-add-condition', this.listCondition);
    },

    handleChangeDataItem(value, index) {
      this.setCondition(true);
      if (index > -1) {
        this.listCondition[index] = value;
        this.$emit('on-add-condition', this.listCondition);
      }
    },
    showDropdownConditionItem() {
      this.isCheckScroll = false;
    },

    handleAddCondition() {
      if (this.listCondition.length === 5 || this.isMetricDetailMode) return;
      this.setCondition(true);
      this.listCondition.push({
        operator: 'AND',
        field: 'message',
        compare: 'like',
        value: ''
      });
      this.$emit('on-add-condition', this.listCondition);
    },

    _setQuery(selected) {
      this.setCondition(true);
      const query = JSON.parse(selected.logQuery);
      this.listCondition = query;
      this.$emit('on-add-condition', this.listCondition);
    },

    togglePopup(key) {
      if (key == 'addMetricShow') {
        if (!this.dataLoaded) {
          window.app.$modal.open({
            rootId: 'app',
            type: 'alert',
            title: this.$t('label.notification'),
            message: this.$t('page.log.addMetric'),
            action: () => {}
          });
        } else {
          let productResourceIds = this.logSqIds.map((item) => item.productResourceId);
          let params = {
            productResourceIds: productResourceIds,
            actionName: 'MonitorSet'
          };
          this.$http.product
            .checkProductAuthorization(params, this.productType, true)
            .then(() => {
              this.popup[key] = !this.popup[key];
            })
            .catch((error) => {
              if (error && error.code == 'AccessDenied') this.$alert(error, () => {});
            });
        }
      } else if (key == 'exeHistoryShow' && !this.popup[key]) {
        let productResourceIds = this.logSqIds.map((item) => item.productResourceId);
        let params = {
          productResourceIds: productResourceIds,
          actionName: 'MonitorView'
        };
        this.$http.product
          .checkProductAuthorization(params, this.productType, true)
          .then(() => {
            this.popup[key] = !this.popup[key];
          })
          .catch((error) => {
            if (error && error.code == 'AccessDenied') this.$alert(error, () => {});
          });
      } else {
        this.popup[key] = !this.popup[key];
      }
    },

    handleSaveMetric(value, description) {
      this.$emit('on-save-metric', value, description);
    },

    handleResetCondition() {
      this.$emit('on-reset');
    },

    handleSearch() {
      let searchOptionValueRefs = [];
      let countWhiteSpace = 0;
      this.listCondition.forEach((item, idx) => {
        if (!item.value.trim() && item.value.length > 0) countWhiteSpace++;
        searchOptionValueRefs.push(this.$refs.conditionItemRefs[idx].$refs.searchOptionValue);
      });

      if (countWhiteSpace === 0) {
        const isValid = this.$util.validate(searchOptionValueRefs);
        if (!isValid) return;
      }

      this.listCondition.forEach((item) => {
        item.value = item.value.trim();
      });

      this.$emit('on-search', this.listCondition);
    },
    onScroll() {
      this.isCheckScroll = true;
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin text-style {
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}

.search-condition-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .ui-icon {
    height: 20px;
  }

  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: calc(100% - 16px - 32px);

    &__action {
      margin-top: 16px;

      .text-add-condition {
        display: flex;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px;
        color: #2c5ad8;
        cursor: pointer;

        &.disabled {
          cursor: default;
          opacity: 0.5;
        }
      }
    }

    &__wrapper-list-condition {
      max-height: calc(100% - 32px - 16px);

      .list {
        padding-right: 24px;
      }
    }
  }

  .execution-history-dialog {
    width: 640px;
    height: auto;
    max-height: 532px;
    padding: 20px 24px;
  }

  ::v-deep {
    .dropdown-left-bottom::after {
      left: 8px;
    }
  }
}

.container__action {
  :deep(.action button) {
    min-width: 80px;
    width: 80px;
  }
}
</style>
